import { Link } from "react-router-dom";

const stats = [
  { value: "15+", label: "精选搭配指南" },
  { value: "3", label: "核心内容分类" },
  { value: "每周", label: "潮流资讯更新" },
];

export default function BrandIntro() {
  return (
    <section className="bg-foreground-950 py-14 text-background-50 md:py-16">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-10 px-4 md:grid-cols-12 md:px-8">
        <div className="md:col-span-7">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-400">About 黑丝</p>
          <h2 className="mt-3 font-heading text-2xl font-bold leading-snug md:text-4xl">
            一条黑丝，穿出属于你的时尚态度
          </h2>
          <p className="mt-5 max-w-xl text-sm leading-relaxed text-background-200/85 md:text-base">
            黑丝是一个专注黑丝丝袜搭配与潮流资讯的时尚内容平台。我们相信，风格不是昂贵单品的堆叠，而是对细节的理解与表达。
            从街头到职场，从日常到派对，我们希望用实用的搭配技巧与前沿的趋势解读，帮助你找到属于自己的那份自信与魅力。
          </p>
          <div className="mt-7 flex flex-wrap gap-4">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-500"
            >
              了解我们
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/specials"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
            >
              浏览专题
            </Link>
          </div>
        </div>

        <div className="md:col-span-5">
          <div className="grid grid-cols-3 gap-3 md:gap-5">
            {stats.map((item) => (
              <div
                key={item.label}
                className="rounded-lg border border-background-50/15 bg-background-50/5 p-4 text-center md:p-5"
              >
                <p className="font-heading text-2xl font-bold text-accent-400 md:text-3xl">{item.value}</p>
                <p className="mt-2 text-xs text-background-200/80 md:text-sm">{item.label}</p>
              </div>
            ))}
          </div>
          <div className="mt-5 rounded-lg border border-background-50/15 bg-background-50/5 p-5">
            <h3 className="font-heading text-lg font-semibold text-background-50">我们的内容承诺</h3>
            <ul className="mt-3 space-y-2 text-sm text-background-200/85">
              <li className="flex items-start gap-2">
                <i className="ri-check-line mt-0.5 text-accent-400" /> 只分享真实可穿的搭配方法
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line mt-0.5 text-accent-400" /> 关注趋势，也尊重每个人的身形与风格
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line mt-0.5 text-accent-400" /> 内容持续更新，陪伴你的每一次尝试
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}